import { editorLocalization } from "survey-creator-core";

export const roStrings = {
  // survey templates
  survey: {
    edit: "Editează",
    externalHelpLink: "Vizionați și învățați cum să creați chestionare",
    externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
    dropQuestion: "Vă rugăm să lăsați o întrebare aici din cutia de instrumente.",
    addLogicItem: "Creați o regulă pentru a personaliza fluxul chestionarului.",
    copy: "Copiază",
    duplicate: "Duplică",
    addToToolbox: "Adaugă în cutia de instrumente",
    deletePanel: "Șterge panoul",
    deleteQuestion: "Șterge întrebarea",
    convertTo: "Convertiți în",
    drag: "Trage elementul",
  },
  // Creator tabs
  tabs: {
    preview: "Previzualizare",
    theme: "Teme",
    translation: "Traduceri",
    designer: "Designer",
    editor: "Editor JSON",
    logic: "Logică"
  },
  // Question types
  qt: {
    default: "Implicit",
    checkbox: "Casete de selectare",
    comment: "Text lung",
    imagepicker: "Selector de imagini",
    ranking: "Clasament",
    image: "Imagine",
    dropdown: "Dropdown",
    tagbox: "Dropdown Multi-Select",
    file: "Încărcare fișier",
    html: "HTML",
    matrix: "Matrice cu selecție unică",
    matrixdropdown: "Matrice cu selecție multiplă",
    matrixdynamic: "Matrice dinamică",
    multipletext: "Casete de text multiple",
    panel: "Panou",
    paneldynamic: "Panou dinamic",
    radiogroup: "Grup de butoane radio",
    rating: "Scală de evaluare",
    text: "Intrare pe un singur rând",
    boolean: "Da/Nu (Boolean)",
    expression: "Expresie (doar citire)",
    signaturepad: "Pad de semnătură",
    buttongroup: "Grup de butoane"
  },
  toolboxCategories: {
    general: "General",
    choice: "Întrebări de alegere",
    text: "Întrebări cu răspuns text",
    containers: "Containere",
    matrix: "Întrebări matrice",
    misc: "Diverse"
  },
  // Strings in SurveyJS Creator
  ed: {
    defaultLocale: "Implicit ({0})",
    survey: "Chestionar",
    settings: "Setări",
    settingsTooltip: "Deschideți setările",
    surveySettings: "Setările chestionarului",
    surveySettingsTooltip: "Setările chestionarului",
    themeSettings: "Setările temei",
    themeSettingsTooltip: "Setările temei",
    showPanel: "Afișează panoul",
    hidePanel: "Ascunde panoul",
    prevSelected: "Selectează precedentul",
    nextSelected: "Selectează următorul",
    prevFocus: "Focalizează pe precedentul",
    nextFocus: "Focalizează pe următorul",
    surveyTypeName: "Chestionar",
    pageTypeName: "Pagină",
    panelTypeName: "Panou",
    questionTypeName: "Întrebare",
    columnTypeName: "Coloană",
    addNewPage: "Adaugă pagină nouă",
    moveRight: "Derulează spre dreapta",
    moveLeft: "Derulează spre stânga",
    deletePage: "Șterge pagina",
    editPage: "Editează pagina",
    edit: "Editează",
    newPageName: "pagină",
    newQuestionName: "întrebare",
    newPanelName: "panou",
    newTextItemName: "text",
    defaultV2Theme: "Implicit",
    modernTheme: "Modern",
    defaultTheme: "Implicit (legacy)",
    testSurveyAgain: "Previzualizați chestionarul din nou",
    testSurveyWidth: "Lățimea chestionarului: ",
    navigateToMsg: "A trebuit să navighezi la",
    saveSurvey: "Salvează chestionarul",
    saveSurveyTooltip: "Salvează chestionarul",
    saveTheme: "Salvează tema",
    saveThemeTooltip: "Salvează tema",
    jsonHideErrors: "Ascunde erorile",
    jsonShowErrors: "Afișează erorile",
    undo: "Anulează",
    redo: "Refă",
    undoTooltip: "Anulează ultima modificare",
    redoTooltip: "Refă modificarea",
    showMoreChoices: "Afișează mai multe",
    showLessChoices: "Afișează mai puține",
    copy: "Copiază",
    cut: "Taie",
    paste: "Lipește",
    copyTooltip: "Copiază selecția în clipboard",
    cutTooltip: "Taie selecția în clipboard",
    pasteTooltip: "Lipește din clipboard",
    options: "Opțiuni",
    generateValidJSON: "Generează JSON valid",
    generateReadableJSON: "Generează JSON lizibil",
    toolbox: "Cutia de instrumente",
    "property-grid": "Proprietăți",
    toolboxFilteredTextPlaceholder: "Tastați pentru a căuta...",
    toolboxNoResultsFound: "Nu au fost găsite rezultate",
    propertyGridFilteredTextPlaceholder: "Tastați pentru a căuta...",
    propertyGridNoResultsFound: "Nu au fost găsite rezultate",
    correctJSON: "Vă rugăm să corectați JSON.",
    surveyResults: "Rezultatele chestionarului ",
    surveyResultsTable: "Ca tabel",
    surveyResultsJson: "Ca JSON",
    resultsTitle: "Titlul întrebării",
    resultsName: "Numele întrebării",
    resultsValue: "Valoarea răspunsului",
    resultsDisplayValue: "Valoare afișată",
    modified: "Modificat",
    saving: "Se salvează",
    saved: "Salvat",
    propertyEditorError: "Eroare",
    saveError: "Eroare! Conținutul editorului nu este salvat.",
    translationPropertyGridTitle: "Setări de limbă",
    themePropertyGridTitle: "Setări de temă",
    translationLanguages: "Limbi",
    translationDeleteLanguage: "Sigur doriți să ștergeți toate șirurile pentru această limbă?",
    translationAddLanguage: "Selectați limba pentru traducere",
    translationShowAllStrings: "Toate șirurile",
    translationShowUsedStringsOnly: "Doar șirurile folosite",
    translationShowAllPages: "Toate paginile",
    translationNoStrings: "Nu există șiruri de tradus. Vă rugăm să schimbați filtrul.",
    translationExportToSCVButton: "Exportă în CSV",
    translationImportFromSCVButton: "Importă din CSV",
    translateUsigAI: "Traducere automată a tuturor",
    translateUsigAIFrom: "Traducere din: ",
    translationDialogTitle: "Șiruri netraduse",
    translationMergeLocaleWithDefault: "Fuzionați {0} cu locația implicită",
    translationPlaceHolder: "Traducere...",
    translationSource: "Sursă: ",
    translationTarget: "Țintă: ",
    themeExportButton: "Exportă",
    themeImportButton: "Importă",
    surveyJsonExportButton: "Exportă",
    surveyJsonImportButton: "Importă",
    surveyJsonCopyButton: "Copiază în clipboard",
    themeResetButton: "Resetează setările temei la implicit",
    themeResetConfirmation: "Sigur doriți să resetați tema? Toate personalizările dvs. vor fi pierdute.",
    themeResetConfirmationOk: "Da, resetează tema",
    bold: "Îngroșat",
    italic: "Italic",
    underline: "Subliniat",
    addNewQuestion: "Adaugă întrebare",
    selectPage: "Selectează pagina...",
    carryForwardChoicesCopied: "Opțiunile sunt copiate de la",
    choicesLoadedFromWebText: "Opțiunile sunt încărcate de la un serviciu web.",
    choicesLoadedFromWebLinkText: "Mergeți la setări",
    choicesLoadedFromWebPreviewTitle: "Previzualizare opțiuni încărcate",
    htmlPlaceHolder: "Conținutul HTML va fi aici.",
    panelPlaceHolder: "Lăsați o întrebare din cutia de instrumente aici.",
    surveyPlaceHolder: "Chestionarul este gol. Trageți un element din cutia de instrumente sau faceți clic pe butonul de mai jos.",
    pagePlaceHolder: "Pagina este goală. Trageți un element din cutia de instrumente sau faceți clic pe butonul de mai jos.",
    imagePlaceHolder: "Trageți și lăsați o imagine aici sau faceți clic pe butonul de mai jos și alegeți o imagine de încărcat",
    surveyPlaceHolderMobile: "Faceți clic pe butonul \"Adaugă întrebare\" de mai jos pentru a începe crearea formularului.",
    pagePlaceHolderMobile: "Faceți clic pe butonul \"Adaugă întrebare\" de mai jos pentru a adăuga un nou element pe pagină.",
    panelPlaceHolderMobile: "Faceți clic pe butonul \"Adaugă întrebare\" de mai jos pentru a adăuga un nou element în panou.",
    imagePlaceHolderMobile: "Faceți clic pe butonul de mai jos și alegeți o imagine de încărcat",
    imageChooseImage: "Alegeți imaginea",
    addNewTypeQuestion: "Adăugați {0}", //{0} is localizable question type
    chooseLogoPlaceholder: "[LOGO]",
    choices_Item: "Element ",
    selectFile: "Selectați un fișier",
    removeFile: "Eliminați fișierul",
    lg: {
      addNewItem: "Adăugați regulă nouă",
      empty_tab: "Creați o regulă pentru a personaliza fluxul chestionarului.",
      page_visibilityName: "Afișează/ascunde pagina",
      page_enableName: "Activează/dezactivează pagina",
      page_requireName: "Fă pagina obligatorie",
      panel_visibilityName: "Afișează/ascunde panoul",
      panel_enableName: "Activează/dezactivează panoul",
      panel_requireName: "Fă panoul obligatoriu",
      question_visibilityName: "Afișează/ascunde întrebarea",
      question_enableName: "Activează/dezactivează întrebarea",
      question_requireName: "Fă întrebarea obligatorie",
      question_resetValueName: "Resetează valoarea întrebării",
      question_setValueName: "Setează valoarea întrebării",
      column_visibilityName: "Afișează/ascunde coloana",
      column_enableName: "Activează/dezactivează coloana",
      column_requireName: "Fă coloana obligatorie",
      column_resetValueName: "Resetează valoarea coloanei",
      column_setValueName: "Setează valoarea coloanei",
      trigger_completeName: "Finalizează chestionarul",
      trigger_setvalueName: "Setează răspunsul",
      trigger_copyvalueName: "Copiază răspunsul",
      trigger_skipName: "Sari la întrebare",
      trigger_runExpressionName: "Execută expresia",
      completedHtmlOnConditionName: "Setează marcajul paginii de „Mulțumire”",
      page_visibilityDescription: "Faceți pagina vizibilă atunci când expresia logică evaluează la adevărat. În caz contrar, mențineți pagina invizibilă.",
      panel_visibilityDescription: "Faceți pagina vizibilă atunci când expresia logică evaluează la adevărat. În caz contrar, mențineți panoul invizibil.",
      panel_enableDescription: "Faceți panoul și toate elementele din interiorul său activate atunci când expresia logică evaluează la adevărat. În caz contrar, mențineți-le dezactivate.",
      question_visibilityDescription: "Faceți întrebarea vizibilă atunci când expresia logică evaluează la adevărat. În caz contrar, mențineți întrebarea invizibilă.",
      question_enableDescription: "Faceți întrebarea activată atunci când expresia logică evaluează la adevărat. În caz contrar, mențineți întrebarea dezactivată.",
      question_requireDescription: "Întrebarea devine obligatorie atunci când expresia logică evaluează la adevărat.",
      trigger_completeDescription: "Când expresia logică evaluează la adevărat, chestionarul se încheie, iar respondentul vede pagina de „Mulțumire”.",
      trigger_setvalueDescription: "Când valorile întrebărilor utilizate în expresia logică se schimbă și expresia evaluează la adevărat, valoarea specificată este atribuită întrebării selectate.",
      trigger_copyvalueDescription: "Când valorile întrebărilor utilizate în expresia logică se schimbă și expresia evaluează la adevărat, valoarea întrebării selectate este copiată în altă întrebare.",
      trigger_skipDescription: "Când expresia logică evaluează la adevărat, chestionarul se concentrează/sare la întrebarea selectată.",
      trigger_runExpressionDescription: "Când expresia logică evaluează la adevărat, chestionarul evaluează o altă expresie. Opțional, rezultatul ultimei expresii poate fi atribuit ca valoare întrebării selectate",
      completedHtmlOnConditionDescription: "Dacă expresia logică evaluează la adevărat, pagina de „Mulțumire” afișează conținutul specificat.",
      itemExpressionText: "Când expresia: '{0}' returnează adevărat", //{0} - the expression
      itemEmptyExpressionText: "Regulă nouă",
      page_visibilityText: "face pagina {0} vizibilă", //{0} page name
      panel_visibilityText: "face panoul {0} vizibil", //{0} panel name
      panel_enableText: "face panoul {0} activ", //{0} panel name
      question_visibilityText: "face întrebarea {0} vizibilă", //{0} question name
      question_enableText: "face întrebarea {0} activă", //{0} question name
      question_requireText: "face întrebarea {0} obligatorie", //{0} question name
      question_resetValueText: "resetează valoarea pentru întrebarea: {0}", //{0} question name.
      question_setValueText: "atribuiți valoarea: {1} întrebării: {0}",
      column_visibilityText: "face coloana {0} a întrebării {1} vizibilă", //{0} column name, {1} question name
      column_enableText: "face coloana {0} a întrebării {1} activă", //{0} column name, {1} question name
      column_requireText: "face coloana {0} a întrebării {1} obligatorie", //{0} column name, {1} question name
      column_resetValueText: "resetează valoarea celulei pentru coloana: {0}", //{0} column name
      column_setValueText: "atribuiți valoarea celulei: {1} coloanei: {0}", //{0} column name and {1} setValueExpression
      setValueExpressionPlaceholder: "O expresie al cărei rezultat va fi atribuit întrebării țintă.",
      trigger_completeText: "chestionarul devine completat",
      trigger_setvalueText: "setați în întrebarea: {0} valoarea {1}", //{0} question name, {1} setValue
      trigger_setvalueEmptyText: "ștergeți valoarea întrebării: {0}", //{0} question name
      trigger_copyvalueText: "copiați în întrebarea: {0} valoarea din întrebarea {1}", //{0} and {1} question names
      trigger_skipText: "chestionarul sare la întrebarea {0}", //{0} question name
      trigger_runExpressionText1: "execută expresia: '{0}'", //{0} the expression
      trigger_runExpressionText2: " și setați rezultatul acesteia în întrebarea: {0}", //{0} question name
      completedHtmlOnConditionText: "afișați text personalizat pentru pagina de „Mulțumire”.",
      showAllQuestions: "Toate întrebările",
      showAllActionTypes: "Toate tipurile de acțiuni",
      conditions: "Condiție(i)",
      actions: "Acțiune(i)",
      expressionEditorTitle: "Definește condiție(i)",
      actionsEditorTitle: "Definește acțiune(i)",
      deleteAction: "Șterge acțiunea",
      addNewAction: "Adaugă acțiune",
      selectedActionCaption: "Selectează acțiunea...",
      expressionInvalid: "Expresia logică este goală sau invalidă. Vă rugăm să o corectați.",
      noActionError: "Vă rugăm să adăugați cel puțin o acțiune.",
      actionInvalid: "Vă rugăm să remediați problemele în acțiunile dvs.",
      uncompletedRule_title: "Regulile logice sunt incomplete",
      uncompletedRule_text: "Nu ați completat unele dintre regulile logice. Dacă părăsiți fila acum, modificările vor fi pierdute. Doriți să părăsiți fila fără a completa modificările?",
      uncompletedRule_apply: "Da",
      uncompletedRule_cancel: "Nu, vreau să completez regulile"
    }
  },
  // Property Editors
  pe: {
    panel: {
      name: "Numele panoului",
      title: "Titlul panoului",
      description: "Descrierea panoului",
      visibleIf: "Fă panoul vizibil dacă",
      requiredIf: "Fă panoul obligatoriu dacă",
      questionsOrder: "Ordinea întrebărilor în panou",
      page: "Mută panoul la pagina",
      startWithNewLine: "Afișează panoul pe un rând nou",
      state: "Starea de colaps a panoului",
      width: "Lățimea panoului inline",
      minWidth: "Lățimea minimă a panoului",
      maxWidth: "Lățimea maximă a panoului",
      showNumber: "Numerotează panourile"
    },
    paneldynamic: {
      name: "Numele panoului",
      title: "Titlul panoului",
      description: "Descrierea panoului",
      visibleIf: "Fă panoul vizibil dacă",
      requiredIf: "Fă panoul obligatoriu dacă",
      page: "Mută panoul la pagina",
      startWithNewLine: "Afișează panoul pe un rând nou",
      state: "Starea de colaps a panoului",
      width: "Lățimea panoului inline",
      minWidth: "Lățimea minimă a panoului",
      maxWidth: "Lățimea maximă a panoului",
      confirmDelete: "Confirmă ștergerea panoului",
      templateDescription: "Model de descriere a panoului",
      templateTitle: "Model de titlu a panoului",
      noEntriesText: "Text panou gol",
      templateTabTitle: "Model de titlu a filei",
      tabTitlePlaceholder: "Locaș pentru titlul filei",
      templateVisibleIf: "Fă un panou individual vizibil dacă",
      hideNumber: "Ascunde numărul panoului",
      titleLocation: "Alinierea titlului panoului",
      descriptionLocation: "Alinierea descrierii panoului",
      templateTitleLocation: "Alinierea titlului întrebării",
      templateErrorLocation: "Alinierea mesajului de eroare",
      newPanelPosition: "Locația noului panou",
      keyName: "Prevenirea răspunsurilor duplicate în următoarea întrebare"
    },
    question: {
      name: "Numele întrebării",
      title: "Titlul întrebării",
      description: "Descrierea întrebării",
      visibleIf: "Fă întrebarea vizibilă dacă",
      requiredIf: "Fă întrebarea obligatorie dacă",
      page: "Mută întrebarea la pagina",
      state: "Starea de colaps a casetei întrebării",
      hideNumber: "Ascunde numărul întrebării",
      titleLocation: "Alinierea titlului întrebării",
      descriptionLocation: "Alinierea descrierii întrebării",
      errorLocation: "Alinierea mesajului de eroare",
      indent: "Crește indentarea internă",
      width: "Lățimea întrebării inline",
      minWidth: "Lățimea minimă a întrebării",
      maxWidth: "Lățimea maximă a întrebării",
      textUpdateMode: "Actualizează valoarea câmpului de intrare"
    },
    signaturepad: {
      signatureWidth: "Lățimea zonei de semnătură",
      signatureHeight: "Înălțimea zonei de semnătură",
      signatureAutoScaleEnabled: "Auto-scalare zona de semnătură",
      showPlaceholder: "Afișează un locaș în zona de semnătură",
      placeholder: "Text locaș",
      placeholderReadOnly: "Text locaș în modul doar citire sau previzualizare",
      allowClear: "Afișează butonul de ștergere în zona de semnătură",
      penMinWidth: "Lățimea minimă a creionului",
      penMaxWidth: "Lățimea maximă a creionului",
      penColor: "Culoarea creionului"
    },
    comment: {
      rows: "Înălțimea câmpului de intrare (în linii)"
    },
    showQuestionNumbers: "Numerotarea întrebărilor",
    questionStartIndex: "Tipul de indexare a întrebărilor",
    expression: {
      name: "Numele expresiei",
      title: "Titlul expresiei",
      description: "Descrierea expresiei",
      expression: "Expresie"
    },
    trigger: {
      expression: "Expresie"
    },
    calculatedvalue: {
      expression: "Expresie"
    },
    // survey templates
    survey: {
      title: "Titlul chestionarului",
      description: "Descrierea chestionarului"
    },
    page: {
      name: "Numele paginii",
      title: "Titlul paginii",
      description: "Descrierea paginii",
      visibleIf: "Fă pagina vizibilă dacă",
      requiredIf: "Fă pagina obligatorie dacă",
      maxTimeToFinish: "Limită de timp pentru finalizarea paginii",
      questionsOrder: "Ordinea întrebărilor pe pagină"
    },
    matrixdropdowncolumn: {
      name: "Numele coloanei",
      title: "Titlul coloanei",
      isUnique: "Prevenirea răspunsurilor duplicate",
      width: "Lățimea coloanei",
      minWidth: "Lățimea minimă a coloanei",
      rows: "Înălțimea câmpului de intrare (în linii)",
      visibleIf: "Fă coloana vizibilă dacă",
      requiredIf: "Fă coloana obligatorie dacă",
      showInMultipleColumns: "Fiecare opțiune într-o coloană separată"
    },
    multipletextitem: {
      name: "Nume",
      title: "Titlu"
    },
    masksettings: {
      saveMaskedValue: "Salvați valoarea mascată în rezultatele chestionarului"
    },
    patternmask: {
      pattern: "Model de valoare"
    },
    datetimemask: {
      min: "Valoarea minimă",
      max: "Valoarea maximă"
    },
    numericmask: {
      allowNegativeValues: "Permiteți valori negative",
      thousandsSeparator: "Separator de mii",
      decimalSeparator: "Separator zecimal",
      precision: "Precizia valorii",
      min: "Valoarea minimă",
      max: "Valoarea maximă"
    },
    currencymask: {
      prefix: "Prefix valutar",
      suffix: "Sufix valutar"
    },
    imageHeight: "Înălțimea zonei de afișare",
    imageWidth: "Lățimea zonei de afișare",
    valueName: "Identificator de îmbinare",
    rateDescriptionLocation: "Alinierea etichetei",
    size: "Lățimea câmpului de intrare (în caractere)",
    cellErrorLocation: "Alinierea mesajului de eroare al celulei",
    enabled: "Activat",
    disabled: "Dezactivat",
    inherit: "Moștenit",
    apply: "Aplică",
    ok: "OK",
    save: "Salvează",
    clear: "Șterge",
    saveTooltip: "Salvează",
    cancel: "Anulează",
    set: "Setează",
    reset: "Resetează",
    change: "Schimbă",
    refresh: "Reîmprospătează",
    close: "Închide",
    delete: "Șterge",
    add: "Adaugă",
    addNew: "Adaugă nou",
    addItem: "Faceți clic pentru a adăuga un element...",
    removeItem: "Faceți clic pentru a elimina elementul...",
    dragItem: "Trageți elementul",
    addOther: "Altul",
    addSelectAll: "Selectează tot",
    addNone: "Niciunul",
    removeAll: "Eliminați tot",
    edit: "Editează",
    back: "Întoarceți-vă fără a salva",
    backTooltip: "Întoarceți-vă fără a salva",
    saveAndBack: "Salvează și întoarce-te",
    saveAndBackTooltip: "Salvează și întoarce-te",
    doneEditing: "Gata",
    editChoices: "Editează alegerile",
    showChoices: "Afișează alegerile",
    move: "Mută",
    empty: "<gol>",
    emptyValue: "Valoarea este goală",
    fastEntry: "Intrare manuală",
    fastEntryNonUniqueError: "Valoarea '{0}' nu este unică",
    fastEntryChoicesCountError: "Vă rugăm să limitați numărul de elemente de la {0} la {1}",
    fastEntryChoicesMinCountError: "Vă rugăm să introduceți cel puțin {0} elemente",
    fastEntryPlaceholder: "Introduceți lista opțiunilor de alegere și ID-urile acestora în următorul format:\n\nid|opțiune\n\nUn ID de opțiune de alegere nu este vizibil pentru respondenți și poate fi utilizat în regulile condiționale.",
    formEntry: "Intrare în formular",
    testService: "Testează serviciul",
    itemSelectorEmpty: "Vă rugăm să selectați elementul",
    conditionActionEmpty: "Vă rugăm să selectați acțiunea",
    conditionSelectQuestion: "Selectează o întrebare...",
    conditionSelectPage: "Selectează o pagină...",
    conditionSelectPanel: "Selectează un panou...",
    conditionValueQuestionTitle: "Vă rugăm să introduceți/selectați valoarea",
    aceEditorHelp: "Apăsați ctrl+spațiu pentru a obține sugestii de completare a expresiei",
    aceEditorRowTitle: "Rândul curent",
    aceEditorPanelTitle: "Panoul curent",
    showMore: "Pentru mai multe detalii, vă rugăm să consultați documentația",
    assistantTitle: "Întrebări disponibile",
    cellsEmptyRowsColumns: "Trebuie să existe cel puțin o coloană sau un rând",
    showPreviewBeforeComplete: "Revizuire înainte de a trimite",
    overridingPropertyPrefix: "Activat de o condiție",
    resetToDefaultCaption: "Resetează",
    propertyIsEmpty: "Vă rugăm să introduceți o valoare",
    propertyIsNoUnique: "Vă rugăm să introduceți o valoare unică",
    propertyNameIsNotUnique: "Vă rugăm să introduceți un nume unic",
    propertyNameIsIncorrect: "Nu folosiți cuvinte rezervate: \"item\", \"choice\", \"panel\", \"row\".",
    listIsEmpty: "Nu aveți încă niciun element",
    "listIsEmpty@choices": "Nu aveți încă nicio alegere",
    "listIsEmpty@columns": "Nu aveți încă nicio coloană",
    "listIsEmpty@rows": "Nu aveți încă niciun rând",
    "listIsEmpty@validators": "Nu aveți încă nicio regulă de validare",
    "listIsEmpty@calculatedValues": "Nu aveți încă nicio variabilă personalizată",
    "listIsEmpty@triggers": "Nu aveți încă niciun declanșator",
    "listIsEmpty@navigateToUrlOnCondition": "Nu aveți încă niciun link",
    "addNew@choices": "Adăugați o alegere nouă",
    "addNew@columns": "Adăugați o coloană nouă",
    "addNew@rows": "Adăugați un rând nou",
    "addNew@validators": "Adăugați o regulă nouă",
    "addNew@calculatedValues": "Adăugați o variabilă nouă",
    "addNew@triggers": "Adăugați un declanșator nou",
    "addNew@navigateToUrlOnCondition": "Adăugați un URL nou",
    expressionIsEmpty: "Expresia este goală",
    value: "Valoare",
    text: "Text",
    rowid: "ID rând",
    imageLink: "URL fișier imagine sau video",
    columnEdit: "Editează coloana: {0}",
    itemEdit: "Editează elementul: {0}",
    url: "URL",
    path: "Calea către date",
    choicesbyurl: {
      url: "URL serviciu web",
      valueName: "Obțineți valoarea de stocat din următoarea proprietate"
    },
    titleName: "Obțineți valoarea de afișat din următoarea proprietate",
    imageLinkName: "Obțineți URL-urile fișierelor din următoarea proprietate",
    allowEmptyResponse: "Acceptă răspuns gol",
    titlePlaceholder: "Titlu",
    surveyTitlePlaceholder: "Titlul chestionarului",
    pageTitlePlaceholder: "Pagina {num}",
    descriptionPlaceholder: "Descriere",
    surveyDescriptionPlaceholder: "Descriere",
    pageDescriptionPlaceholder: "Descriere",
    textWrapEnabled: "Înfășurați alegerile",
    showOtherItem: "Activează opțiunea „Altul”",
    otherText: "Redenumește opțiunea „Altul”",
    showNoneItem: "Activează opțiunea „Niciunul”",
    showRefuseItem: "Activează opțiunea „Refuz să răspund”",
    showDontKnowItem: "Activează opțiunea „Nu știu”",
    noneText: "Redenumește opțiunea „Niciunul”",
    showSelectAllItem: "Activează opțiunea „Selectează tot”",
    selectAllText: "Redenumește opțiunea „Selectează tot”",
    choicesMin: "Valoarea minimă pentru elementele auto-generate",
    choicesMax: "Valoarea maximă pentru elementele auto-generate",
    choicesStep: "Valoarea pasului pentru elementele auto-generate",
    name: "Nume",
    title: "Titlu",
    cellType: "Tip intrare celulă",
    colCount: "Număr de coloane",
    choicesOrder: "Ordinea alegerilor",
    visible: "Vizibil",
    isRequired: "Obligatoriu",
    markRequired: "Marchează ca obligatoriu",
    removeRequiredMark: "Elimină marcajul obligatoriu",
    isAllRowRequired: "Necesită un răspuns în fiecare rând",
    eachRowUnique: "Prevenirea răspunsurilor duplicate în rânduri",
    requiredErrorText: "Mesaj de eroare pentru întrebările obligatorii",
    startWithNewLine: "Afișează întrebarea pe un rând nou",
    rows: "Rânduri",
    cols: "Coloane",
    placeholder: "Text locaș în câmpul de intrare",
    showPreview: "Afișează zona de previzualizare",
    storeDataAsText: "Stocați conținutul fișierului în rezultatul JSON ca text",
    maxSize: "Dimensiunea maximă a fișierului (în octeți)",
    rowCount: "Număr de rânduri",
    columnLayout: "Aspect coloane",
    addRowLocation: "Alinierea butonului „Adaugă rând”",
    transposeData: "Transpune rândurile în coloane",
    addRowText: "Textul butonului „Adaugă rând”",
    removeRowText: "Textul butonului „Elimină rând”",
    rateMin: "Valoarea minimă a evaluării",
    rateMax: "Valoarea maximă a evaluării",
    rateStep: "Valoarea pasului",
    minRateDescription: "Etichetă valoare minimă",
    maxRateDescription: "Etichetă valoare maximă",
    inputType: "Tip intrare",
    optionsCaption: "Locaș opțiune",
    defaultValue: "Răspuns implicit",
    cellsDefaultRow: "Texte implicite",
    surveyEditorTitle: "Editează setările chestionarului",
    qEditorTitle: "Editează: {0}",
    maxLength: "Limită maximă de caractere",
    buildExpression: "Construiește",
    editExpression: "Editează",
    and: "și",
    or: "sau",
    remove: "Elimină",
    addCondition: "Adaugă condiție",
    emptyLogicPopupMessage: "Selectați o întrebare pentru a începe configurarea condițiilor.",
    if: "Dacă",
    then: "atunci",
    setToName: "Întrebarea țintă",
    fromName: "Întrebarea de unde se copiază răspunsul",
    gotoName: "Întrebarea la care săriți",
    ruleIsNotSet: "Regula este incorectă",
    includeIntoResult: "Adăugați la rezultatele chestionarului",
    showTitle: "Faceți titlul și descrierea vizibile",
    expandCollapseTitle: "Extinde/colapsează titlul",
    locale: "Selectați o limbă pentru chestionar",
    simulator: "Selectați tipul de dispozitiv",
    landscapeOrientation: "Comutați la orientarea peisaj",
    portraitOrientation: "Comutați la orientarea portret",
    mode: "Modul de afișare a chestionarului",
    clearInvisibleValues: "Ștergeți valorile întrebărilor ascunse",
    cookieName: "Limitează la un singur răspuns",
    sendResultOnPageNext: "Auto-salvați progresul chestionarului la schimbarea paginii",
    storeOthersAsComment: "Salvați valoarea opțiunii „Altul” ca proprietate separată",
    showPageTitles: "Afișați titlurile paginilor",
    showPageNumbers: "Afișați numerele paginilor",
    pagePrevText: "Textul butonului „Pagina anterioară”",
    pageNextText: "Textul butonului „Pagina următoare”",
    completeText: "Textul butonului „Completează chestionarul”",
    previewText: "Textul butonului „Revizuiește răspunsurile”",
    editText: "Textul butonului „Editează răspunsul”",
    startSurveyText: "Textul butonului „Începe chestionarul”",
    showNavigationButtons: "Afișați/ascundeți butoanele de navigare",
    showPrevButton: "Afișați butonul „Pagina anterioară”",
    firstPageIsStarted: "Prima pagină este o pagină de început",
    showCompletedPage: "Afișați pagina de „Mulțumire”",
    goNextPageAutomatic: "Trecerea automată la pagina următoare",
    allowCompleteSurveyAutomatic: "Finalizați chestionarul automat",
    showProgressBar: "Alinierea barei de progres",
    questionTitleLocation: "Alinierea titlului întrebării",
    questionTitleWidth: "Lățimea titlului întrebării",
    requiredText: "Simbol(uri) obligatoriu(e)",
    questionTitleTemplate: "Șablon titlu întrebare, implicit este: '{no}. {require} {title}'",
    questionErrorLocation: "Alinierea mesajului de eroare",
    focusFirstQuestionAutomatic: "Focalizați pe prima întrebare la o pagină nouă",
    questionsOrder: "Ordinea întrebărilor",
    maxTimeToFinish: "Limită de timp pentru finalizarea chestionarului",
    maxTimeToFinishPage: "Limită de timp pentru finalizarea unei pagini",
    showTimerPanel: "Alinierea timerului",
    showTimerPanelMode: "Modul timerului",
    renderMode: "Modul de afișare a panoului",
    allowAddPanel: "Permite adăugarea panoului",
    allowRemovePanel: "Permite eliminarea panoului",
    panelAddText: "Textul butonului „Adaugă panou”",
    panelRemoveText: "Textul butonului „Elimină panou”",
    isSinglePage: "Afișează toate elementele pe o singură pagină",
    html: "Marcaj HTML",
    setValue: "Răspuns",
    dataFormat: "Format de stocare",
    allowAddRows: "Permite adăugarea rândului",
    allowRemoveRows: "Permite eliminarea rândului",
    allowRowsDragAndDrop: "Permite reordonarea rândurilor",
    responsiveImageSizeHelp: "Nu se aplică dacă specificați lățimea sau înălțimea exactă a zonei de afișare.",
    minImageWidth: "Lățimea minimă a zonei de afișare",
    maxImageWidth: "Lățimea maximă a zonei de afișare",
    minImageHeight: "Înălțimea minimă a zonei de afișare",
    maxImageHeight: "Înălțimea maximă a zonei de afișare",
    minValue: "Valoarea minimă",
    maxValue: "Valoarea maximă",
    minLength: "Lungimea minimă (în caractere)",
    allowDigits: "Permiteți cifre",
    minCount: "Numărul minim",
    maxCount: "Numărul maxim",
    regex: "Expresie regulată",
    surveyvalidator: {
      text: "Mesaj de eroare",
      expression: "Expresie de validare"
    },
    totalText: "Antet rând total",
    totalType: "Metoda de agregare",
    totalExpression: "Expresie valoare totală",
    totalDisplayStyle: "Format de afișare a valorii totale",
    totalCurrency: "Monedă",
    totalFormat: "Șir formatat",
    logo: "Logo-ul chestionarului",
    questionsOnPageMode: "Aspectul chestionarului",
    maxTextLength: "Restricționează lungimea răspunsului",
    maxOthersLength: "Restricționează lungimea comentariului",
    commentAreaRows: "Înălțimea zonei de comentarii (în linii)",
    autoGrowComment: "Auto-extindere a zonelor de text",
    allowResizeComment: "Permite utilizatorilor să redimensioneze zonele de text",
    textUpdateMode: "Actualizează valorile câmpurilor de intrare",
    maskType: "Tip mască de intrare",
    focusOnFirstError: "Focalizați pe primul răspuns invalid",
    checkErrorsMode: "Rulați validarea",
    validateVisitedEmptyFields: "Validarea câmpurilor goale pentru focalizarea pierdută",
    navigateToUrl: "Redirecționare către un link extern după trimitere",
    navigateToUrlOnCondition: "Link extern dinamic",
    completedBeforeHtml: "Marcaj de afișat dacă utilizatorul a completat deja acest chestionar",
    completedHtml: "Marcaj pagina de „Mulțumire”",
    completedHtmlOnCondition: "Marcaj dinamic pentru pagina de „Mulțumire”",
    loadingHtml: "Marcaj de afișat în timp ce modelul chestionarului se încarcă",
    commentText: "Text zona de comentarii",
    autocomplete: "Tip autocompletare",
    labelTrue: "Etichetă pentru „Adevărat”",
    labelFalse: "Etichetă pentru „Fals”",
    allowClear: "Afișează butonul de ștergere",
    searchMode: "Modul de căutare",
    displayStyle: "Format de afișare",
    format: "Șir formatat",
    maximumFractionDigits: "Numărul maxim de cifre fracționare",
    minimumFractionDigits: "Numărul minim de cifre fracționare",
    useGrouping: "Afișează separatori de grupare",
    allowMultiple: "Permite încărcarea multiplă de fișiere",
    allowImagesPreview: "Previzualizează imaginile încărcate",
    acceptedTypes: "Tipuri de fișiere acceptate",
    waitForUpload: "Așteptați finalizarea încărcării",
    needConfirmRemoveFile: "Confirmați ștergerea fișierului",
    detailPanelMode: "Alinierea extinderii rândului",
    minRowCount: "Număr minim de rânduri",
    maxRowCount: "Număr maxim de rânduri",
    confirmDelete: "Confirmați ștergerea rândului",
    confirmDeleteText: "Mesaj de confirmare",
    panelCount: "Număr inițial de panouri",
    minPanelCount: "Număr minim de panouri",
    maxPanelCount: "Număr maxim de panouri",
    panelsState: "Starea de colaps a panoului intern",
    panelPrevText: "Textul butonului „Panoul anterior”",
    panelNextText: "Textul butonului „Panoul următor”",
    showRangeInProgress: "Afișați bara de progres",
    panelRemoveButtonLocation: "Alinierea butonului „Elimină panou”",
    hideIfRowsEmpty: "Ascunde întrebarea dacă nu are rânduri",
    hideColumnsIfEmpty: "Ascunde coloanele dacă nu sunt rânduri",
    rateValues: "Valori personalizate de evaluare",
    rateCount: "Număr de evaluări",
    autoGenerate: "Configurare evaluare",
    hideIfChoicesEmpty: "Ascunde întrebarea dacă nu are alegeri",
    minWidth: "Lățime minimă",
    maxWidth: "Lățime maximă",
    width: "Lățime",
    showHeader: "Afișează anteturile coloanelor",
    horizontalScroll: "Afișează bara de derulare orizontală",
    columnMinWidth: "Lățimea minimă a coloanei",
    rowTitleWidth: "Lățimea antetului rândului",
    valueTrue: "Valoare de stocat când se selectează „Adevărat”",
    valueFalse: "Valoare de stocat când se selectează „Fals”",
    minErrorText: "Mesaj de eroare pentru „Valoarea este sub minim”",
    maxErrorText: "Mesaj de eroare pentru „Valoarea depășește maximul”",
    otherErrorText: "Mesaj de eroare pentru „Comentariu gol”",
    keyDuplicationError: "Mesaj de eroare pentru răspunsuri duplicate",
    minSelectedChoices: "Alegere minimă pentru selectare",
    maxSelectedChoices: "Alegere maximă pentru selectare",
    showClearButton: "Afișează butonul de ștergere",
    logoWidth: "Lățimea logo-ului",
    logoHeight: "Înălțimea logo-ului",
    readOnly: "Doar citire",
    enableIf: "Dezactivează modul doar citire dacă",
    emptyRowsText: "Mesaj „Nu sunt rânduri”",
    separateSpecialChoices: "Separă alegerile speciale",
    choicesFromQuestion: "Copiază alegerile din următoarea întrebare",
    choicesFromQuestionMode: "Care opțiuni de alegere să fie copiate",
    progressBarShowPageTitles: "Afișează titlurile paginilor în bara de progres",
    progressBarShowPageNumbers: "Afișează numerele paginilor în bara de progres",
    showCommentArea: "Adaugă o casetă de comentarii",
    commentPlaceholder: "Text locaș pentru caseta de comentarii",
    displayRateDescriptionsAsExtremeItems: "Afișați etichetele ca valori extreme",
    rowsOrder: "Ordinea rândurilor",
    columnsLayout: "Aspect coloane",
    columnColCount: "Număr coloane imbricate",
    correctAnswer: "Răspuns corect",
    defaultPanelValue: "Valori implicite",
    cells: "Texte celulă",
    fileInputPlaceholder: "Selectați un fișier sau introduceți un link către fișier...",
    keyName: "Prevenirea răspunsurilor duplicate în următoarea coloană",
    itemvalue: {
      visibleIf: "Fă opțiunea vizibilă dacă",
      enableIf: "Fă opțiunea selectabilă dacă"
    },
    "itemvalue@rows": {
      visibleIf: "Fă rândul vizibil dacă",
      enableIf: "Fă rândul editabil dacă"
    },
    imageitemvalue: {
      text: "Text alternativ"
    },
    logoPosition: "Alinierea logo-ului",
    addLogo: "Adăugați logo...",
    changeLogo: "Schimbați logo...",
    logoPositions: {
      none: "Eliminați logo-ul",
      left: "Stânga",
      right: "Dreapta",
      top: "Deasupra",
      bottom: "Dedesubt"
    },
    // Creator tabs
    tabs: {
      panel: {
        layout: "Aspect panou"
      },
      general: "General",
      fileOptions: "Opțiuni",
      html: "Editor HTML",
      columns: "Coloane",
      rows: "Rânduri",
      choices: "Opțiuni de alegere",
      items: "Elemente",
      visibleIf: "Vizibil dacă",
      enableIf: "Editabil dacă",
      requiredIf: "Obligatoriu dacă",
      rateValues: "Valori evaluare",
      choicesByUrl: "Alegeri dintr-un serviciu web",
      matrixChoices: "Alegeri implicite",
      multipleTextItems: "Câmpuri de text",
      numbering: "Numerotare",
      validators: "Validatori",
      navigation: "Navigare",
      question: "Setări întrebare",
      pages: "Pagini",
      timer: "Modul chestionar",
      calculatedValues: "Valori calculate",
      triggers: "Declanșatori",
      templateTitle: "Șablon titlu",
      totals: "Totaluri",
      logic: "Condiții",
      mask: "Setări mască de intrare",
      layout: {
        panel: "Aspect panou",
        question: "Aspect",
        base: "Aspect"
      },
      data: "Date",
      validation: "Validare",
      cells: "Texte celulă individuale",
      showOnCompleted: "Pagina de „Mulțumire”",
      logo: "Logo-ul în antetul chestionarului",
      slider: "Slider",
      expression: "Expresie",
      questionSettings: "Setări întrebare",
      header: "Antet",
      background: "Fundal",
      appearance: "Aspect",
      others: "Altele"
    },
    editProperty: "Editează proprietatea '{0}'",
    items: "Elemente",
    choicesVisibleIf: "Fă alegerile vizibile dacă",
    choicesEnableIf: "Fă alegerile selectabile dacă",
    columnsEnableIf: "Fă coloanele vizibile dacă",
    rowsEnableIf: "Fă rândurile vizibile dacă",
    innerIndent: "Crește indentarea internă",
    defaultValueFromLastRow: "Utilizează răspunsurile din ultimul rând ca implicite",
    defaultValueFromLastPanel: "Utilizează răspunsurile din ultimul panou ca implicite",
    enterNewValue: "Vă rugăm să introduceți o valoare.",
    noquestions: "Nu există întrebări în chestionar.",
    createtrigger: "Vă rugăm să creați un declanșator",
    titleKeyboardAdornerTip: "Apăsați butonul Enter pentru a edita",
    keyboardAdornerTip: "Apăsați butonul Enter pentru a edita elementul, apăsați butonul Ștergere pentru a șterge elementul, apăsați Alt + săgeată în sus sau în jos pentru a muta elementul",
    triggerOn: "Pe ",
    triggerMakePagesVisible: "Fă paginile vizibile",
    triggerMakeQuestionsVisible: "Fă elementele vizibile",
    triggerCompleteText: "Completează chestionarul dacă este de succes.",
    triggerNotSet: "Declanșatorul nu este setat",
    triggerRunIf: "Execută dacă",
    triggerSetToName: "Schimbă valoarea pentru: ",
    triggerFromName: "Copiază valoarea de la: ",
    triggerRunExpression: "Execută această expresie",
    triggerSetValue: "la: ",
    triggerGotoName: "Sari la întrebarea",
    triggerIsVariable: "Nu adăuga variabila în rezultatul chestionarului.",
    triggerRunExpressionEmpty: "Vă rugăm să introduceți o expresie validă",
    emptyExpressionPlaceHolder: "Tastați expresia aici...",
    noFile: "Niciun fișier ales",
    clearIfInvisible: "Ștergeți valorile întrebărilor ascunse",
    valuePropertyName: "Stocați valorile în următoarea proprietate",
    searchEnabled: "Activează căutarea în timp real",
    hideSelectedItems: "Ascunde elementele selectate",
    closeOnSelect: "Colapsează lista derulantă la selecție",
    verticalAlign: "Aliniere verticală în celule",
    alternateRows: "Culori alternante ale rândurilor",
    columnsVisibleIf: "Fă coloanele vizibile dacă",
    rowsVisibleIf: "Fă rândurile vizibile dacă",
    otherPlaceholder: "Text locaș pentru caseta de comentarii",
    filePlaceholder: "Text locaș pentru fișier local",
    photoPlaceholder: "Text locaș pentru cameră",
    fileOrPhotoPlaceholder: "Text locaș pentru fișier local sau cameră",
    rateType: "Pictogramă de evaluare",
    url_placeholder: "Ex.: https://api.example.com/cărți",
    path_placeholder: "Ex.: categorii.ficțiune",
    questionStartIndex_placeholder: "Ex.: a)",
    width_placeholder: "Ex.: 6in",
    minWidth_placeholder: "Ex.: 600px",
    maxWidth_placeholder: "Ex.: 50%",
    imageHeight_placeholder: "auto",
    imageWidth_placeholder: "auto",
    theme: {
      themeName: "Temă",
      isPanelless: "Aspect întrebări",
      editorPanel: "Fundal și rază de colț",
      questionPanel: "Fundal și rază de colț",
      primaryColor: "Culoare accent",
      panelBackgroundTransparency: "Opacitatea panoului și a casetei de întrebări",
      questionBackgroundTransparency: "Opacitatea elementelor de intrare",
      fontSize: "Dimensiunea fontului chestionarului",
      scale: "Factor de scalare chestionar",
      cornerRadius: "Raza colțului",
      pageTitle: "Font titlu",
      pageDescription: "Font descriere",
      questionTitle: "Font titlu",
      questionDescription: "Font descriere",
      editorFont: "Font",
      backgroundOpacity: "Opacitate",
      "--sjs-font-family": "Familia fontului chestionarului",
      "--sjs-general-backcolor-dim": "Culoarea fundalului",
      "--sjs-primary-backcolor": "Culorile fundalului accent",
      "--sjs-primary-forecolor": "Culorile primului plan accent",
      "--sjs-special-red": "Culorile mesajului de eroare",
      "--sjs-shadow-small": "Efecte de umbră",
      "--sjs-shadow-inner": "Efecte de umbră",
      "--sjs-border-default": "Culori"
    },
    "header@header": {
      headerView: "Vizualizare",
      logoPosition: "Alinierea logo-ului",
      surveyTitle: "Font titlu chestionar",
      surveyDescription: "Font descriere chestionar",
      headerTitle: "Font titlu chestionar",
      headerDescription: "Font descriere chestionar",
      inheritWidthFrom: "Lățimea zonei de conținut",
      textAreaWidth: "Lățimea textului",
      backgroundColorSwitch: "Culoarea fundalului",
      backgroundImage: "Imagine fundal",
      backgroundImageOpacity: "Opacitate",
      overlapEnabled: "Suprapunere",
      logoPositionX: "Alinierea logo-ului",
      titlePositionX: "Alinierea titlului chestionarului",
      descriptionPositionX: "Alinierea descrierii chestionarului"
    }
  },
  // Property values
  pv: {
    "true": "adevărat",
    "false": "fals",
    file: "Fișier local",
    camera: "Cameră",
    "file-camera": "Fișier local sau cameră",
    inherit: "Moștenit",
    show: "Vizibil",
    hide: "Ascuns",
    default: "Moștenit",
    initial: "Inițial",
    random: "Aleatoriu",
    collapsed: "Colapsat",
    expanded: "Extins",
    none: "Niciunul",
    asc: "Ascendent",
    desc: "Descendent",
    indeterminate: "Nedeterminat",
    selected: "Selectat",
    unselected: "Neselectat",
    decimal: "zecimal",
    currency: "valută",
    percent: "procent",
    firstExpanded: "Primul panou este extins",
    off: "Ascunde numerele întrebărilor",
    list: "Listă",
    progressTop: "Navigator panou + bară de progres în partea de sus",
    progressBottom: "Navigator panou + bară de progres în partea de jos",
    progressTopBottom: "Navigator panou + bară de progres în partea de sus și de jos",
    tab: "File",
    horizontal: "Orizontal",
    vertical: "Vertical",
    top: "Deasupra",
    bottom: "Dedesubt",
    topBottom: "Deasupra și dedesubt",
    both: "Ambele",
    left: "Stânga",
    right: "Dreapta",
    center: "Centru",
    leftRight: "Stânga și dreapta",
    middle: "Mijloc",
    color: "culoare",
    date: "dată",
    datetime: "data și ora",
    "datetime-local": "data și ora locală",
    email: "email",
    month: "lună",
    number: "număr",
    password: "parolă",
    range: "interval",
    tel: "număr de telefon",
    text: "text",
    time: "ora",
    url: "URL",
    week: "săptămână",
    hidden: "Ascuns",
    edit: "Editabil",
    display: "Doar citire",
    contain: "Conține",
    cover: "Acoperă",
    fill: "Umple",
    next: "Următor",
    last: "Ultim",
    onComplete: "La finalizarea chestionarului",
    onHidden: "Când întrebarea este ascunsă",
    onHiddenContainer: "Când întrebarea sau panoul/pagina este ascuns(ă)",
    clearInvisibleValues: {
      none: "Niciodată"
    },
    clearIfInvisible: {
      none: "Niciodată"
    },
    inputType: {
      color: "Culoare",
      date: "Dată",
      "datetime-local": "Dată și oră",
      email: "Email",
      month: "Lună",
      number: "Număr",
      password: "Parolă",
      range: "Interval",
      tel: "Număr de telefon",
      text: "Text",
      time: "Ora",
      url: "URL",
      week: "Săptămână"
    },
    maskType: {
      none: "Niciunul",
      pattern: "Model",
      numeric: "Numerică",
      datetime: "Data și ora",
      currency: "Valută"
    },
    inputTextAlignment: {
      auto: "Automobil",
      left: "Stânga",
      right: "Dreapta"
    },
    all: "Toate",
    page: "Pagină",
    survey: "Chestionar",
    onNextPage: "La trecerea la pagina următoare",
    onValueChanged: "După modificarea unui răspuns",
    onValueChanging: "Înainte de modificarea unui răspuns",
    questionsOnPageMode: {
      standard: "Structură originală",
      singlePage: "Afișați toate întrebările pe o singură pagină",
      questionPerPage: "Afișați o singură întrebare pe pagină"
    },
    noPreview: "Fără previzualizare",
    showAllQuestions: "Afișați toate întrebările",
    showAnsweredQuestions: "Afișați doar întrebările la care s-a răspuns",
    pages: "Pagini completate",
    questions: "Întrebări cu răspuns",
    requiredQuestions: "Întrebări obligatorii cu răspuns",
    correctQuestions: "Răspunsuri valide",
    buttons: "Pagini completate (interfață buton)",
    underInput: "Sub câmpul de intrare",
    underTitle: "Sub titlul întrebării",
    onBlur: "La pierderea focalizării",
    onTyping: "În timp ce se tastează",
    underRow: "Sub rând",
    underRowSingle: "Sub rând, afișați doar o singură extindere de rând",
    auto: "Auto",
    showNavigationButtons: {
      none: "Ascuns"
    },
    showTimerPanel: {
      none: "Ascuns"
    },
    showTimerPanelMode: {
      all: "Ambele"
    },
    addRowLocation: {
      default: "Pe baza aspectului matricei"
    },
    panelsState: {
      default: "Blocat",
      collapsed: "Colapsați toate",
      expanded: "Extindeți toate",
      firstExpanded: "Primul extins"
    },
    widthMode: {
      static: "Static",
      responsive: "Responsive"
    },
    contentMode: {
      image: "Imagine",
      video: "Video",
      youtube: "YouTube"
    },
    displayMode: {
      buttons: "Butoane",
      dropdown: "Dropdown"
    },
    rateColorMode: {
      default: "Implicit",
      scale: "Scară"
    },
    scaleColorMode: {
      monochrome: "Monocrom",
      colored: "Colorat"
    },
    autoGenerate: {
      "true": "Auto-generat",
      "false": "Manual"
    },
    rateType: {
      labels: "Etichete",
      stars: "Stele",
      smileys: "Emoji"
    },
    state: {
      default: "Blocat"
    },
    showQuestionNumbers: {
      default: "Auto-numerotare",
      on: "Auto-numerotare",
      onPage: "Resetare pe fiecare pagină",
      onpanel: "Resetare pe fiecare panou",
      onPanel: "Resetare pe fiecare panou",
      onSurvey: "Continuă pe tot chestionarul",
      off: "Fără numerotare"
    },
    descriptionLocation: {
      underTitle: "Sub titlul întrebării",
      underInput: "Sub câmpul de intrare"
    },
    selectToRankAreasLayout: {
      horizontal: "Lângă alegeri",
      vertical: "Deasupra alegerilor"
    },
    displayStyle: {
      decimal: "Zecimal",
      currency: "Valută",
      percent: "Procent",
      date: "Dată"
    },
    totalDisplayStyle: {
      decimal: "Zecimal",
      currency: "Valută",
      percent: "Procent",
      date: "Dată"
    },
    rowsOrder: {
      initial: "Original"
    },
    questionsOrder: {
      initial: "Original"
    },
    showProgressBar: {
      off: "Ascuns",
      topbottom: "Deasupra și dedesubt",
      aboveheader: "Deasupra antetului",
      belowheader: "Sub antet"
    },
    sum: "Sumă",
    count: "Numără",
    min: "Min",
    max: "Max",
    avg: "Medie",
    searchMode: {
      contains: "Conține",
      startsWith: "Începe cu"
    },
    backgroundImageFit: {
      auto: "Auto",
      cover: "Acoperă",
      contain: "Conține",
      fill: "Umple",
      tile: "Placă"
    },
    backgroundImageAttachment: {
      fixed: "Fix",
      scroll: "Derulare"
    },
    headerView: {
      basic: "De bază",
      advanced: "Avansat"
    },
    inheritWidthFrom: {
      survey: "La fel ca chestionarul",
      container: "La fel ca containerul"
    },
    backgroundColorSwitch: {
      none: "Niciunul",
      accentColor: "Culoare accent",
      custom: "Personalizat"
    },
    colorPalette: {
      light: "Deschis",
      dark: "Întunecat"
    },
    isPanelless: {
      "false": "Implicit",
      "true": "Fără panouri"
    },
    progressBarInheritWidthFrom: {
      survey: "La fel ca sondajul",
      container: "La fel ca containerul"
    }
  },
  // Operators
  op: {
    empty: "Gol",
    notempty: "Nu este gol",
    equal: "Egal cu",
    notequal: "Nu este egal cu",
    contains: "Conține",
    notcontains: "Nu conține",
    anyof: "Oricare dintre",
    allof: "Toate dintre",
    greater: "Mai mare decât",
    less: "Mai mic decât",
    greaterorequal: "Mai mare sau egal cu",
    lessorequal: "Mai mic sau egal cu",
    and: "și",
    or: "sau"
  },
  // Embed window
  ew: {
    angular: "Utilizați versiunea Angular",
    jquery: "Utilizați versiunea jQuery",
    knockout: "Utilizați versiunea Knockout",
    react: "Utilizați versiunea React",
    vue: "Utilizați versiunea Vue",
    bootstrap: "Pentru cadrul bootstrap",
    modern: "Tema modernă",
    default: "Tema implicită",
    orange: "Tema portocalie",
    darkblue: "Tema albastru închis",
    darkrose: "Tema trandafir închis",
    stone: "Tema piatră",
    winter: "Tema iarnă",
    winterstone: "Tema iarnă-piatră",
    showOnPage: "Afișați chestionarul pe o pagină",
    showInWindow: "Afișați chestionarul într-o fereastră",
    loadFromServer: "Încărcați JSON-ul chestionarului de pe server",
    titleScript: "Scripturi și stiluri",
    titleHtml: "HTML",
    titleJavaScript: "JavaScript"
  },
  // Preview (Survey)
  ts: {
    selectPage: "Selectați pagina pentru a o testa",
    showInvisibleElements: "Afișează elementele invizibile",
    hideInvisibleElements: "Ascunde elementele invizibile"
  },
  validators: {
    answercountvalidator: "Număr de răspunsuri",
    emailvalidator: "Email",
    expressionvalidator: "Expresie",
    numericvalidator: "Număr",
    regexvalidator: "Expresie regulată",
    textvalidator: "Text"
  },
  triggers: {
    completetrigger: "Completează chestionarul",
    setvaluetrigger: "Setează răspunsul",
    copyvaluetrigger: "Copiază răspunsul",
    skiptrigger: "Sari la întrebare",
    runexpressiontrigger: "Execută expresia",
    visibletrigger: "schimbare vizibilitate (depreciat)"
  },
  peplaceholder: {
    patternmask: {
      pattern: "Ex.: +1(999)-999-99-99"
    },
    datetimemask: {
      pattern: "Ex.: mm/dd/yyyy HH:MM:ss"
    },
    currencymask: {
      prefix: "Ex.: $",
      suffix: "Ex.: USD"
    },
    panelbase: {
      questionTitleWidth: "Ex.: 200px"
    },
    panellayoutcolumn: {
      effectiveWidth: "Ex.: 30%",
      questionTitleWidth: "Ex.: 200px"
    }
  },
  pehelp: {
    panel: {
      name: "Un ID al panoului care nu este vizibil pentru respondenți.",
      description: "Introduceți un subtitlu pentru panou.",
      visibleIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care determină vizibilitatea panoului.",
      enableIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care dezactivează modul doar citire pentru panou.",
      requiredIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care împiedică trimiterea chestionarului dacă cel puțin o întrebare inclusă nu are un răspuns.",
      questionTitleLocation: "Se aplică tuturor întrebărilor din acest panou. Dacă doriți să înlocuiți această setare, definiți reguli de aliniere a titlului pentru întrebările individuale. Opțiunea „Moștenește” aplică setarea de la nivel de pagină (dacă este setată) sau setarea de la nivel de chestionar („Sus” implicit).",
      questionTitleWidth: "Setează lățimea titlurilor întrebărilor atunci când sunt aliniate la stânga casetelor de întrebări. Acceptă valori CSS (px, %, in, pt etc.).",
      questionErrorLocation: "Setează locația unui mesaj de eroare în raport cu toate întrebările din panou. Opțiunea „Moștenește” aplică setarea de la nivel de pagină (dacă este setată) sau setarea de la nivel de chestionar.",
      questionsOrder: "Păstrează ordinea originală a întrebărilor sau le randomizează. Opțiunea „Moștenește” aplică setarea de la nivel de pagină (dacă este setată) sau setarea de la nivel de chestionar.",
      page: "Repoziționează panoul la sfârșitul unei pagini selectate.",
      innerIndent: "Adaugă spațiu sau margine între conținutul panoului și marginea stângă a casetei panoului.",
      startWithNewLine: "Deselectați pentru a afișa panoul pe un rând cu întrebarea sau panoul anterior. Setarea nu se aplică dacă panoul este primul element din formular.",
      state: "Alegeți dintre: „Extins” - panoul este afișat complet și poate fi colapsat; „Colapsat” - panoul afișează doar titlul și descrierea și poate fi extins; „Blocat” - panoul este afișat complet și nu poate fi colapsat.",
      width: "Setează lățimea panoului în proporție cu alte elemente ale chestionarului de pe același rând. Acceptă valori CSS (px, %, in, pt etc.)."
    },
    paneldynamic: {
      name: "Un ID al panoului care nu este vizibil pentru respondenți.",
      description: "Introduceți un subtitlu pentru panou.",
      visibleIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care determină vizibilitatea panoului.",
      enableIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care dezactivează modul doar citire pentru panou.",
      requiredIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care împiedică trimiterea chestionarului dacă cel puțin o întrebare inclusă nu are un răspuns.",
      templateTitleLocation: "Se aplică tuturor întrebărilor din acest panou. Dacă doriți să înlocuiți această setare, definiți reguli de aliniere a titlului pentru întrebările individuale. Opțiunea „Moștenește” aplică setarea de la nivel de pagină (dacă este setată) sau setarea de la nivel de chestionar („Sus” implicit).",
      templateErrorLocation: "Setează locația unui mesaj de eroare în raport cu o întrebare cu intrare invalidă. Alegeți dintre: „Sus” - un text de eroare este plasat în partea de sus a casetei întrebării; „Jos” - un text de eroare este plasat în partea de jos a casetei întrebării. Opțiunea „Moștenește” aplică setarea de la nivel de pagină (dacă este setată) sau setarea de la nivel de chestionar („Sus” implicit).",
      errorLocation: "Setează locația unui mesaj de eroare în raport cu toate întrebările din panou. Opțiunea „Moștenește” aplică setarea de la nivel de pagină (dacă este setată) sau setarea de la nivel de chestionar.",
      page: "Repoziționează panoul la sfârșitul unei pagini selectate.",
      innerIndent: "Adaugă spațiu sau margine între conținutul panoului și marginea stângă a casetei panoului.",
      startWithNewLine: "Deselectați pentru a afișa panoul pe un rând cu întrebarea sau panoul anterior. Setarea nu se aplică dacă panoul este primul element din formular.",
      state: "Alegeți dintre: „Extins” - panoul este afișat complet și poate fi colapsat; „Colapsat” - panoul afișează doar titlul și descrierea și poate fi extins; „Blocat” - panoul este afișat complet și nu poate fi colapsat.",
      width: "Setează lățimea panoului în proporție cu alte elemente ale chestionarului de pe același rând. Acceptă valori CSS (px, %, in, pt etc.).",
      templateTitle: "Introduceți un șablon pentru titlurile panourilor dinamice. Utilizați {panelIndex} pentru poziția generală a panoului și {visiblePanelIndex} pentru ordinea acestuia printre panourile vizibile. Introduceți aceste substituenți în model pentru a adăuga numerotare automată.",
      templateTabTitle: "Introduceți un șablon pentru titlurile filelor. Utilizați {panelIndex} pentru poziția generală a unui panou și {visiblePanelIndex} pentru ordinea acestuia printre panourile vizibile. Introduceți aceste substituenți în model pentru a adăuga numerotare automată.",
      tabTitlePlaceholder: "Un text fallback pentru titlurile filelor care se aplică atunci când șablonul titlului filei nu produce o valoare semnificativă.",
      templateVisibleIf: "Această setare vă permite să controlați vizibilitatea panourilor individuale din panoul dinamic. Utilizați substituentul `{panel}` pentru a face referire la panoul curent în expresia dvs.",
      titleLocation: "Această setare este moștenită automat de toate întrebările din acest panou. Dacă doriți să înlocuiți această setare, definiți reguli de aliniere a titlului pentru întrebările individuale. Opțiunea „Moștenește” aplică setarea de la nivel de pagină (dacă este setată) sau setarea de la nivel de chestionar („Sus” implicit).",
      descriptionLocation: "Opțiunea „Moștenește” aplică setarea de la nivel de pagină (dacă este setată) sau setarea de la nivel de chestionar („Sub titlul panoului” implicit).",
      newPanelPosition: "Definește poziția unui panou nou adăugat. În mod implicit, panourile noi sunt adăugate la sfârșit. Selectați „Următor” pentru a introduce un nou panou după cel curent.",
      defaultValueFromLastPanel: "Duplică răspunsurile din ultimul panou și le atribuie următorului panou dinamic adăugat.",
      keyName: "Faceți referire la un nume de întrebare pentru a solicita unui utilizator să furnizeze un răspuns unic pentru această întrebare în fiecare panou."
    },
    defaultValueExpression: "Această setare vă permite să atribuiți o valoare implicită a răspunsului pe baza unei expresii. Expresia poate include calcule de bază - `{q1_id} + {q2_id}`, expresii booleene, cum ar fi `{age} > 60`, și funcții: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. Valoarea determinată de această expresie servește ca valoare implicită inițială care poate fi suprascrisă de o intrare manuală a respondentului.",
    resetValueIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care determină când o intrare a respondentului este resetată la valoarea pe baza „Expresiei valorii implicite” sau „Expresiei de setare a valorii” sau la valoarea „Răspuns implicit” (dacă oricare este setată).",
    setValueIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care determină când să rulați „Expresia de setare a valorii” și să atribuiți dinamic valoarea rezultată ca răspuns.",
    setValueExpression: "Specificați o expresie care definește valoarea ce trebuie setată atunci când condițiile din regula „Setați valoarea dacă” sunt îndeplinite. Expresia poate include calcule de bază - `{q1_id} + {q2_id}`, expresii booleene, cum ar fi `{age} > 60`, și funcții: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. Valoarea determinată de această expresie poate fi suprascrisă de o intrare manuală a respondentului.",
    question: {
      name: "Un ID al întrebării care nu este vizibil pentru respondenți.",
      description: "Introduceți un subtitlu pentru întrebare.",
      visibleIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care determină vizibilitatea întrebării.",
      enableIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care dezactivează modul doar citire pentru întrebare.",
      requiredIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care împiedică avansarea sau trimiterea chestionarului dacă întrebarea nu a primit un răspuns.",
      startWithNewLine: "Deselectați pentru a afișa întrebarea pe un rând cu întrebarea sau panoul anterior. Setarea nu se aplică dacă întrebarea este primul element din formular.",
      page: "Repoziționează întrebarea la sfârșitul unei pagini selectate.",
      state: "Alegeți dintre: „Extins” - caseta întrebării este afișată complet și poate fi colapsată; „Colapsat” - caseta întrebării afișează doar titlul și descrierea și poate fi extinsă; „Blocat” - caseta întrebării este afișată complet și nu poate fi colapsată.",
      titleLocation: "Înlocuiește regulile de aliniere a titlului definite la nivel de panou, pagină sau chestionar. Opțiunea „Moștenește” aplică orice setare de nivel superior (dacă este setată) sau setarea de la nivel de chestionar („Sus” implicit).",
      descriptionLocation: "Opțiunea „Moștenește” aplică setarea de la nivel de chestionar („Sub titlul întrebării” implicit).",
      errorLocation: "Setează locația unui mesaj de eroare în raport cu întrebarea cu intrare invalidă. Alegeți dintre: „Sus” - un text de eroare este plasat în partea de sus a casetei întrebării; „Jos” - un text de eroare este plasat în partea de jos a casetei întrebării. Opțiunea „Moștenește” aplică setarea de la nivel de chestionar („Sus” implicit).",
      indent: "Adaugă spațiu sau margine între conținutul întrebării și marginea stângă a casetei întrebării.",
      width: "Setează lățimea întrebării în proporție cu alte elemente ale chestionarului de pe același rând. Acceptă valori CSS (px, %, in, pt etc.).",
      surveyvalidator: {
        expression: "Utilizați pictograma bagheta magică pentru a seta o regulă de validare pentru întrebare."
      },
      textUpdateMode: "Alegeți dintre: „La pierderea focalizării” - valoarea este actualizată când câmpul de intrare pierde focalizarea; „În timp ce se tastează” - valoarea este actualizată în timp real, pe măsură ce utilizatorii tastează. Opțiunea „Moștenește” aplică setarea de la nivel de chestionar („La pierderea focalizării” implicit).",
      url: "Puteți utiliza orice serviciu web ca sursă de date pentru întrebările cu multiple opțiuni de alegere. Pentru a popula valorile opțiunilor, introduceți URL-ul serviciului care furnizează datele.",
      searchMode: "O operație de comparație utilizată pentru a filtra lista derulantă.",
      textWrapEnabled: "Textele lungi din opțiunile de alegere vor genera automat întreruperi de linie pentru a se încadra în meniul derulant. Deselectați dacă doriți ca textele să fie tăiate."
    },
    signaturepad: {
      signatureWidth: "Setează lățimea zonei de semnătură afișate și a imaginii rezultate.",
      signatureHeight: "Setează înălțimea zonei de semnătură afișate și a imaginii rezultate.",
      signatureAutoScaleEnabled: "Selectați dacă doriți ca zona de semnătură să umple tot spațiul disponibil din caseta întrebării menținând aspectul implicit 3:2. Când sunt setate valori de lățime și înălțime personalizate, setarea va menține aspectul acestor dimensiuni."
    },
    file: {
      imageHeight: "Reglează înălțimea imaginii în rezultatele chestionarului.",
      imageWidth: "Reglează lățimea imaginii în rezultatele chestionarului.",
      allowImagesPreview: "Afișează previzualizări în miniatură pentru fișierele încărcate atunci când este posibil. Deselectați dacă doriți să afișați pictogramele fișierelor."
    },
    image: {
      contentMode: "Opțiunea „Auto” determină automat modul potrivit pentru afișare - Imagine, Video sau YouTube - pe baza URL-ului sursă furnizat."
    },
    imagepicker: {
      imageHeight: "Înlocuiește valorile minime și maxime de înălțime.",
      imageWidth: "Înlocuiește valorile minime și maxime de lățime.",
      choices: "\"Valoare\" servește ca un ID al elementului utilizat în regulile condiționale; „Text” este afișat respondenților.",
      contentMode: "Alegeți între „Imagine” și „Video” pentru a seta modul de conținut al selectorului media. Dacă este selectată „Imagine”, asigurați-vă că toate opțiunile furnizate sunt fișiere de imagine în următoarele formate: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. În mod similar, dacă este selectat „Video”, asigurați-vă că toate opțiunile sunt linkuri directe către fișiere video în următoarele formate: MP4, MOV, WMV, FLV, AVI, MKV. Vă rugăm să rețineți că linkurile YouTube nu sunt acceptate pentru opțiunile video."
    },
    text: {
      size: "Această setare redimensionează doar câmpul de intrare și nu afectează lățimea casetei întrebării. Pentru a limita lungimea acceptată a intrării, accesați <b>Validare → Limită maximă de caractere</b>."
    },
    comment: {
      rows: "Setează numărul de linii afișate în câmpul de intrare. Dacă intrarea ocupă mai multe linii, va apărea bara de derulare."
    },
    // survey templates
    survey: {
      mode: "Alegeți între: „Editabil” - permite respondenților să completeze chestionarul dvs.; „Doar citire” - dezactivează editarea formularului."
    },
    matrixdropdowncolumn: {
      name: "Un ID al coloanei care nu este vizibil pentru respondenți.",
      isUnique: "Când este activată pentru o coloană, un respondent este obligat să furnizeze un răspuns unic pentru fiecare întrebare din această coloană.",
      rows: "Setează numărul de linii afișate în câmpul de intrare. Dacă intrarea ocupă mai multe linii, va apărea bara de derulare.",
      visibleIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care determină vizibilitatea coloanei.",
      enableIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care dezactivează modul doar citire pentru coloană.",
      requiredIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care împiedică trimiterea chestionarului dacă cel puțin o întrebare inclusă nu are un răspuns.",
      showInMultipleColumns: "Când este selectat, creează o coloană individuală pentru fiecare opțiune de alegere."
    },
    widthMode: "Alegeți dintre: „Static” - setează o lățime fixă; „Responsive” - face ca chestionarul să ocupe întreaga lățime a ecranului; „Auto” - aplică una dintre cele două în funcție de tipurile de întrebări utilizate.",
    cookieName: "Atribuiți o valoare unică cookie-ului pentru chestionarul dvs. Cookie-ul va fi setat în browserul unui respondent la finalizarea chestionarului pentru a preveni trimiterea repetată a chestionarului.",
    logo: "Introduceți un link către o imagine (fără limită de dimensiune) sau faceți clic pe pictograma folder pentru a naviga un fișier de pe computerul dvs. (până la 64KB).",
    logoWidth: "Setează o lățime a logo-ului în unități CSS (px, %, in, pt etc.).",
    logoHeight: "Setează o înălțime a logo-ului în unități CSS (px, %, in, pt etc.).",
    logoFit: "Alegeți dintre: „Niciunul” - imaginea își menține dimensiunea originală; „Conține” - imaginea este redimensionată pentru a se potrivi păstrând aspectul său; „Acoperă” - imaginea umple întreaga casetă păstrând aspectul său; „Umple” - imaginea este întinsă pentru a umple caseta fără a păstra aspectul său.",
    goNextPageAutomatic: "Selectați dacă doriți ca chestionarul să avanseze automat la pagina următoare după ce un respondent răspunde la toate întrebările de pe pagina curentă.",
    allowCompleteSurveyAutomatic: "Selectați dacă doriți ca chestionarul să se completeze automat după ce un respondent răspunde la toate întrebările.",
    showNavigationButtons: "Setează vizibilitatea și locația butoanelor de navigare pe o pagină.",
    showProgressBar: "Setează vizibilitatea și locația unei bare de progres. Valoarea „Auto” afișează bara de progres deasupra sau dedesubtul antetului chestionarului.",
    showPreviewBeforeComplete: "Activează pagina de previzualizare cu toate sau doar întrebările la care s-a răspuns.",
    questionTitleLocation: "Se aplică tuturor întrebărilor din chestionar. Această setare poate fi înlocuită de regulile de aliniere a titlului la niveluri inferioare: panou, pagină sau întrebare. O setare de nivel inferior va înlocui setările de nivel superior.",
    requiredText: "Un simbol sau o secvență de simboluri care indică faptul că este necesar un răspuns.",
    questionStartIndex: "Introduceți un număr sau o literă cu care doriți să începeți numerotarea.",
    questionErrorLocation: "Setează locația unui mesaj de eroare în raport cu întrebarea cu intrare invalidă. Alegeți dintre: „Sus” - un text de eroare este plasat în partea de sus a casetei întrebării; „Jos” - un text de eroare este plasat în partea de jos a casetei întrebării.",
    focusFirstQuestionAutomatic: "Selectați dacă doriți ca primul câmp de intrare de pe fiecare pagină să fie pregătit pentru introducerea textului.",
    questionsOrder: "Păstrează ordinea originală a întrebărilor sau le randomizează. Efectul acestei setări este vizibil doar în fila Previzualizare.",
    maxTextLength: "Doar pentru întrebările de introducere a textului.",
    maxOthersLength: "Doar pentru comentariile întrebărilor.",
    commentAreaRows: "Setează numărul de linii afișate în zonele de text pentru comentariile întrebărilor. Dacă introducerea ocupă mai multe linii, va apărea bara de derulare.",
    autoGrowComment: "Selectați dacă doriți ca comentariile întrebărilor și întrebările de Text lung să se extindă automat în funcție de lungimea textului introdus.",
    allowResizeComment: "Doar pentru comentariile întrebărilor și întrebările de Text lung.",
    calculatedValues: "Variabilele personalizate servesc drept variabile intermediare sau auxiliareutilizate în calculele formularului. Acestea iau intrările respondenților ca valori sursă. Fiecare variabilă personalizată are un nume unic și o expresie pe care se bazează.",
    includeIntoResult: "Selectați dacă doriți ca valoarea calculată a expresiei să fie salvată împreună cu rezultatele chestionarului.",
    triggers: "Un declanșator este un eveniment sau o condiție bazată pe o expresie. Odată ce expresia este evaluată ca „adevărată”, declanșatorul declanșează o acțiune. O astfel de acțiune poate avea opțional o întrebare țintă pe care o afectează.",
    clearInvisibleValues: "Alegeți dacă doriți sau nu să ștergeți valorile întrebărilor ascunse prin logica condițională și când să o faceți.",
    textUpdateMode: "Alegeți dintre: „La pierderea focalizării” - valoarea este actualizată când câmpul de intrare pierde focalizarea; „În timp ce se tastează” - valoarea este actualizată în timp real, pe măsură ce utilizatorii tastează.",
    columns: "Valoarea din stânga servește ca ID al coloanei utilizat în regulile condiționale, valoarea din dreapta este afișată respondenților.",
    rows: "Valoarea din stânga servește ca ID al rândului utilizat în regulile condiționale, valoarea din dreapta este afișată respondenților.",
    columnMinWidth: "Acceptă valori CSS (px, %, in, pt etc.).",
    rowTitleWidth: "Acceptă valori CSS (px, %, in, pt etc.).",
    totalText: "Vizibil numai dacă cel puțin o coloană afișează valorile totale setate cu „Metoda de agregare” sau „Expresia valorii totale”.",
    cellErrorLocation: "Setează locația unui mesaj de eroare în raport cu o celulă cu intrare invalidă. Opțiunea „Moștenește” aplică setarea din proprietatea „Alinierea mesajului de eroare”.",
    keyDuplicationError: "Când proprietatea „Împiedică răspunsurile duplicate” este activată, un respondent care încearcă să trimită o intrare duplicat va primi următorul mesaj de eroare.",
    totalExpression: "Vă permite să calculați valorile totale pe baza unei expresii. Expresia poate include calcule de bază (`{q1_id} + {q2_id}`), expresii booleene (`{age} > 60`) și funcții (`iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.).",
    confirmDelete: "Declanșează un prompt care solicită confirmarea ștergerii rândului.",
    defaultValueFromLastRow: "Duplică răspunsurile din ultimul rând și le atribuie următorului rând dinamic adăugat.",
    keyName: "Faceți referire la un ID al coloanei pentru a solicita unui utilizator să furnizeze un răspuns unic pentru fiecare întrebare din coloana specificată.",
    description: "Introduceți un subtitlu.",
    locale: "Alegeți o limbă pentru a începe să creați chestionarul. Pentru a adăuga o traducere, comutați la o limbă nouă și traduceți textul original aici sau în fila Traduceri.",
    detailPanelMode: "Setează locația unei secțiuni de detalii în raport cu un rând. Alegeți dintre: „Niciunul” - nu se adaugă nicio extindere; „Sub rând” - o extindere a rândului este plasată sub fiecare rând al matricei; „Sub rând, afișați doar o singură extindere de rând” - o extindere este afișată sub un singur rând, celelalte extinderi de rând fiind colapsate.",
    imageFit: "Alegeți dintre: „Niciunul” - imaginea își menține dimensiunea originală; „Conține” - imaginea este redimensionată pentru a se potrivi păstrând aspectul său; „Acoperă” - imaginea umple întreaga casetă păstrând aspectul său; „Umple” - imaginea este întinsă pentru a umple caseta fără a păstra aspectul său.",
    autoGrow: "Opțiunea „Moștenește” aplică setarea de la nivel de chestionar („Dezactivat” implicit).",
    allowResize: "Opțiunea „Moștenește” aplică setarea de la nivel de chestionar („Activat” implicit).",
    maxTimeToFinish: "Un interval de timp în secunde după care chestionarul avansează automat la pagina „Mulțumim”.",
    maxTimeToFinishPage: "Un interval de timp în secunde după care chestionarul avansează automat la pagina următoare. Ascunde butonul de navigare „Anterior”.",
    validateVisitedEmptyFields: "Activați această opțiune pentru a declanșa validarea atunci când un utilizator se concentrează pe un câmp de introducere gol și apoi îl lasă fără a efectua modificări.",
    page: {
      maxTimeToFinish: "Un interval de timp în secunde după care chestionarul avansează automat la pagina următoare. Ascunde butonul de navigare „Anterior”.",
      visibleIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care determină vizibilitatea paginii.",
      enableIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care dezactivează modul doar citire pentru pagină.",
      requiredIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care împiedică trimiterea chestionarului dacă cel puțin o întrebare inclusă nu are un răspuns.",
      questionTitleLocation: "Se aplică tuturor întrebărilor din această pagină. Dacă doriți să înlocuiți această setare, definiți reguli de aliniere a titlului pentru întrebările individuale sau panouri. Opțiunea „Moștenește” aplică setarea de la nivel de chestionar („Sus” implicit).",
      questionTitleWidth: "Setează lățimea titlurilor întrebărilor atunci când sunt aliniate la stânga casetelor de întrebări. Acceptă valori CSS (px, %, in, pt etc.).",
      questionErrorLocation: "Setează locația unui mesaj de eroare în raport cu întrebarea cu intrare invalidă. Alegeți dintre: „Sus” - un text de eroare este plasat în partea de sus a casetei întrebării; „Jos” - un text de eroare este plasat în partea de jos a casetei întrebării. Opțiunea „Moștenește” aplică setarea de la nivel de chestionar.",
      questionsOrder: "Păstrează ordinea originală a întrebărilor sau le randomizează. Opțiunea „Moștenește” aplică setarea de la nivel de chestionar („Original” implicit). Efectul acestei setări este vizibil doar în fila Previzualizare.",
      navigationButtonsVisibility: "Setează vizibilitatea butoanelor de navigare pe pagină. Opțiunea „Moștenește” aplică setarea de la nivel de chestionar, care implicit este „Vizibilă”."
    },
    showTimerPanel: "Setează vizibilitatea și locația unui cronometru pe o pagină.",
    panelsState: "Alegeți dintre: „Blocat” - utilizatorii nu pot extinde sau colapsa panouri; „Colapsați toate” - toate panourile încep într-o stare colapsată; „Extindeți toate” - toate panourile încep într-o stare extinsă; „Primul extins” - doar primul panou este extins inițial. Se aplică dacă „Modul de afișare a panoului” este setat la „Listă” și proprietatea „Șablon titlu panou” este specificată.",
    imageLinkName: "Introduceți un nume de proprietate comun în cadrul array-ului de obiecte care conține URL-urile fișierelor imagine sau video pe care doriți să le afișați în lista de opțiuni.",
    choices: "Valoarea din stânga servește ca un ID al elementului utilizat în regulile condiționale, valoarea din dreapta este afișată respondenților.",
    title: "Introduceți un titlu prietenos pentru utilizator care să fie afișat.",
    waitForUpload: "Asigură că utilizatorii nu vor putea finaliza chestionarul până când fișierele nu sunt încărcate.",
    minWidth: "Acceptă valori CSS (px, %, in, pt etc.).",
    maxWidth: "Acceptă valori CSS (px, %, in, pt etc.).",
    width: "Acceptă valori CSS (px, %, in, pt etc.).",
    valueName: "Un identificator comun este o cheie personalizată pe care o puteți atribui mai multor întrebări pentru a le lega împreună și a sincroniza valorile acestora. Aceste valori vor fi îmbinate într-un singur array sau obiect și stocate în rezultatele chestionarului folosind cheia ca nume de proprietate.",
    useDisplayValuesInDynamicTexts: "În tipurile de întrebări de selecție unică și multiplă, fiecare opțiune de alegere are un ID și o valoare de afișare. Când este selectată, această setare afișează o valoare de afișare în loc de o valoare ID în întrebările HTML și în titlurile și descrierile dinamice ale elementelor chestionarului.",
    clearIfInvisible: "Alegeți dacă doriți sau nu să ștergeți valorile întrebărilor ascunse prin logica condițională și când să o faceți. Opțiunea „Moștenește” aplică setarea de la nivel de chestionar („La finalizarea chestionarului” implicit).",
    choicesFromQuestionMode: "Alegeți dintre: „Toate” - copiază toate opțiunile de alegere din întrebarea selectată; „Selectate” - copiază dinamic doar opțiunile de alegere selectate; „Neselectate” - copiază dinamic doar opțiunile de alegere neselectate. Opțiunile „Niciuna” și „Altele” sunt copiate implicit dacă sunt activate în întrebarea sursă.",
    showOtherItem: "Când este selectat, utilizatorii pot include intrare suplimentară într-o casetă de comentarii separată.",
    separateSpecialChoices: "Afișează fiecare opțiune de alegere specială („Niciuna”, „Altele”, „Selectează toate”) pe un rând nou, chiar și atunci când utilizați un layout pe mai multe coloane.",
    path: "Specificați locația din cadrul setului de date al serviciului unde se află array-ul de obiecte țintă. Lăsați gol dacă URL-ul indică deja către array.",
    choicesbyurl: {
      valueName: "Introduceți un nume de proprietate uniform în cadrul array-ului de obiecte a cărui valoare va fi stocată ca răspuns în rezultatele chestionarului."
    },
    titleName: "Introduceți un nume de proprietate uniform în cadrul array-ului de obiecte care conține valorile pe care doriți să le afișați în lista de opțiuni.",
    allowEmptyResponse: "Selectați pentru a permite serviciului să returneze un răspuns sau un array gol.",
    choicesVisibleIf: "Utilizați pictograma bagheta magică pentru a seta o regulă condițională care determină vizibilitatea tuturor opțiunilor de alegere.",
    rateValues: "Valoarea din stânga servește ca un ID al elementului utilizat în regulile condiționale, valoarea din dreapta este afișată respondenților.",
    rating: {
      displayMode: "\"Auto\" selectează între modurile „Butoane” și „Dropdown” pe baza lățimii disponibile. Când lățimea este insuficientă pentru a afișa butoanele, întrebarea afișează un meniu derulant."
    },
    valuePropertyName: "Vă permite să conectați întrebările care produc rezultate în diferite formate. Când astfel de întrebări sunt legate împreună folosind un identificator comun, această proprietate partajată stochează valorile întrebărilor selectate.",
    searchEnabled: "Selectați dacă doriți să actualizați conținutul meniului derulant pentru a se potrivi cu interogarea de căutare pe care un utilizator o tastează în câmpul de intrare.",
    valueTrue: "O valoare de salvat în rezultatele chestionarului atunci când respondenții oferă un răspuns pozitiv.",
    valueFalse: "O valoare de salvat în rezultatele chestionarului atunci când respondenții oferă un răspuns negativ.",
    showPreview: "Nu este recomandat să dezactivați această opțiune, deoarece suprascrie Previzualizarea imaginii și face dificilă pentru utilizator înțelegerea dacă fișierele au fost încărcate.",
    needConfirmRemoveFile: "Declanșează un prompt care solicită confirmarea ștergerii fișierului.",
    selectToRankEnabled: "Activați pentru a clasifica doar opțiunile selectate. Utilizatorii vor trage elementele selectate din lista de opțiuni pentru a le ordona în zona de clasificare.",
    dataList: "Introduceți o listă de opțiuni care vor fi sugerate respondentului în timpul introducerii.",
    itemSize: "Setarea redimensionează doar câmpurile de intrare și nu afectează lățimea casetei întrebării.",
    itemTitleWidth: "Setează o lățime consistentă pentru toate etichetele elementelor în pixeli",
    inputTextAlignment: "Selectați modul de aliniere a valorii de intrare în câmp. Setarea implicită \"Auto\" aliniază valoarea de intrare la dreapta dacă se aplică mascare monedară sau numerică și la stânga dacă nu.",
    altText: "Servește ca un substitut atunci când imaginea nu poate fi afișată pe dispozitivul utilizatorului și pentru scopuri de accesibilitate.",
    rateColorMode: "Definește culoarea emoji-ului selectat când tipul pictogramei de evaluare este setat la „Smileys”. Alegeți dintre: „Implicit” - emoji-ul selectat apare în culoarea implicită a chestionarului; „Scală” - emoji-ul selectat moștenește culoarea de la scala de evaluare.",
    expression: {
      name: "Un ID al expresiei care nu este vizibil pentru respondenți.",
      description: "Introduceți un subtitlu pentru expresie.",
      expression: "O expresie poate include calcule de bază (`{q1_id} + {q2_id}`), condiții (`{age} > 60`) și funcții ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)."
    },
    storeOthersAsComment: "Selectați pentru a stoca valoarea opțiunii „Altele” ca o proprietate separată în rezultatele chestionarului.",
    format: "Utilizați {0} ca substituent pentru valoarea actuală.",
    acceptedTypes: "Consultați descrierea atributului [accept](https://www.w3schools.com/tags/att_input_accept.asp) pentru mai multe informații.",
    columnColCount: "Se aplică doar dacă „Tip de intrare a celulei” este setat la Grup de butoane radio sau Casete de selectare.",
    autocomplete: "Selectați tipul de date pe care browserul utilizatorului îl poate recupera. Aceste date sunt sursă fie din valorile introduse anterior de utilizator, fie din valorile preconfigurate dacă există valori salvate de utilizator pentru completare automată.",
    filePlaceholder: "Se aplică atunci când „Tip sursă fișier” este „Fișier local” sau când camera nu este disponibilă",
    photoPlaceholder: "Se aplică atunci când „Tip sursă fișier” este „Cameră”.",
    fileOrPhotoPlaceholder: "Se aplică atunci când „Tip sursă fișier” este „Fișier local sau cameră”.",
    colCount: "Aranjează opțiunile de alegere într-un layout pe mai multe coloane. Când este setat la 0, opțiunile sunt afișate pe un singur rând.",
    masksettings: {
      saveMaskedValue: "Selectați dacă doriți să stocați valoarea întrebării cu o mască aplicată în rezultatele chestionarului."
    },
    patternmask: {
      pattern: "Modelul poate conține litere de șir și următorii substituenți: `9` - pentru o cifră; `a` - pentru o literă mare sau mică; `#` - pentru o cifră sau o literă mare sau mică. Utilizați backslash `\\` pentru a scăpa un caracter."
    },
    datetimemask: {
      pattern: "Modelul poate conține caractere de separator și următorii substituenți:<br>`m` - Număr lună.<br>`mm` - Număr lună, cu zero la început pentru valori de o cifră.<br>`d` - Ziua lunii.<br>`dd` - Ziua lunii, cu zero la început pentru valori de o cifră.<br>`yy` - Ultimele două cifre ale anului.<br>`yyyy` - An de patru cifre.<br>`H` - Ore în format 24 de ore.<br>`HH` - Ore în format 24 de ore, cu zero la început pentru valori de o cifră.<br>`h` - Ore în format 12 de ore.<br>` `hh` - Ore în format de 12 ore, cu zero înainte pentru valorile cu o singură cifră.<br>`MM` - Minute.<br>`ss` - Secunde.<br>`TT` - Perioada de ceas de 12 ore cu litere mari (AM/PM).<br>`tt` - perioada ceasului de 12 ore cu litere mici (am/pm)"
    },
    numericmask: {
      decimalSeparator: "Un simbol folosit pentru a separa partea fracționară de partea întreagă a unui număr afișat.",
      thousandsSeparator: "Un simbol folosit pentru a separa cifrele unui număr mare în grupuri de câte trei.",
      precision: "Limitează câte cifre să fie reținute după punctul zecimal pentru un număr afișat."
    },
    currencymask: {
      prefix: "Unul sau mai multe simboluri care să fie afișate înaintea valorii.",
      suffix: "Unul sau mai multe simboluri care să fie afișate după valoare."
    },
    theme: {
      isPanelless: "Această setare se aplică doar întrebărilor din afara unui panou.",
      primaryColor: "Setează o culoare suplimentară care evidențiază elementele cheie ale chestionarului.",
      panelBackgroundTransparency: "Ajustează transparența panourilor și casetelor de întrebări în raport cu fundalul chestionarului.",
      questionBackgroundTransparency: "Ajustează transparența elementelor de intrare în raport cu fundalul chestionarului.",
      cornerRadius: "Setează raza colțurilor pentru toate elementele dreptunghiulare. Activați modul avansat dacă doriți să setați valori individuale pentru raza colțurilor pentru elementele de intrare sau panourile și casetele de întrebări.",
      "--sjs-general-backcolor-dim": "Setează culoarea principală a fundalului chestionarului."
    },
    header: {
      inheritWidthFrom: "Opțiunea \"La fel ca și containerul\" ajustează automat lățimea zonei de conținut a antetului pentru a se potrivi în elementul HTML în care este plasat chestionarul.",
      textAreaWidth: "Lățimea zonei de antet care conține titlul și descrierea chestionarului, măsurată în pixeli.",
      overlapEnabled: "Face ca partea de jos a antetului să fie suprapusă cu partea de sus a chestionarului."
    },
    panellayoutcolumn: {
      effectiveWidth: "Acceptă valori în %.",
      questionTitleWidth: "Acceptă valori în px."
    },
    progressBarInheritWidthFrom: "Opțiunea \"La fel ca containerul\" ajustează automat lățimea zonei barei de progres pentru a se potrivi cu elementul HTML în care este plasat sondajul."
  },
  // Properties
  p: {
    title: {
      name: "title",
      title: "Lăsați gol, dacă este la fel ca 'Nume'"
    },
    multiSelect: "Permite selecția multiplă",
    showLabel: "Arată subtitlurile pentru imagini și videoclipuri",
    swapOrder: "Schimbă ordinea dintre Da și Nu",
    value: "Valoare",
    tabAlign: "Alinierea tabului",
    sourceType: "Tipul sursei de fișier",
    fitToContainer: "Potrivește în container",
    setValueExpression: "Setează expresia valorii",
    description: "Descriere",
    logoFit: "Potrivirea logo-ului",
    pages: "Pagini",
    questions: "Întrebări",
    triggers: "Declanșatori",
    calculatedValues: "Variabile personalizate",
    surveyId: "ID-ul chestionarului",
    surveyPostId: "ID-ul postării chestionarului",
    surveyShowDataSaving: "Afișează salvarea datelor chestionarului",
    questionDescriptionLocation: "Alinierea descrierii întrebării",
    progressBarType: "Tipul barei de progres",
    showTOC: "Arată tabelul de conținut (TOC)",
    tocLocation: "Alinierea TOC",
    questionTitlePattern: "Modelul titlului întrebării",
    widthMode: "Modul de lățime al chestionarului",
    showBrandInfo: "Arată informații despre marcă",
    useDisplayValuesInDynamicTexts: "Utilizați valorile afișate în textele dinamice",
    visibleIf: "Vizibil dacă",
    defaultValueExpression: "Expresia valorii implicite",
    requiredIf: "Necesar dacă",
    resetValueIf: "Resetați valoarea dacă",
    setValueIf: "Setează valoarea dacă",
    validators: "Reguli de validare",
    bindings: "Legături",
    renderAs: "Renderizare ca",
    attachOriginalItems: "Atașați elementele originale",
    choices: "Opțiuni",
    choicesByUrl: "Opțiuni de la URL",
    currency: "Valută",
    cellHint: "Sugestie celulă",
    totalMaximumFractionDigits: "Numărul maxim de zecimale totale",
    totalMinimumFractionDigits: "Numărul minim de zecimale totale",
    columns: "Coloane",
    detailElements: "Elemente detaliate",
    allowAdaptiveActions: "Permite acțiuni adaptive",
    defaultRowValue: "Valoarea implicită a rândului",
    detailPanelShowOnAdding: "Afișează panoul detaliat la adăugare",
    choicesLazyLoadEnabled: "Încărcare întârziată activată pentru opțiuni",
    choicesLazyLoadPageSize: "Dimensiunea paginii pentru încărcarea întârziată a opțiunilor",
    inputFieldComponent: "Componenta câmpului de intrare",
    itemComponent: "Componentă element",
    min: "Min",
    max: "Max",
    minValueExpression: "Expresia valorii minime",
    maxValueExpression: "Expresia valorii maxime",
    step: "Pas",
    dataList: "Elemente pentru sugestii automate",
    itemSize: "Lățimea câmpului de intrare (în caractere)",
    itemTitleWidth: "Lățimea etichetei elementului (în px)",
    inputTextAlignment: "Alinierea valorilor de intrare",
    elements: "Elemente",
    content: "Conținut",
    navigationButtonsVisibility: "Arată/ascunde butoanele de navigare",
    navigationTitle: "Titlul navigării",
    navigationDescription: "Descrierea navigării",
    longTap: "Apăsare lungă",
    autoGrow: "Extinderea dinamică a câmpului de intrare",
    allowResize: "Permite redimensionarea",
    acceptCarriageReturn: "Acceptă întoarcerea la linie",
    displayMode: "Mod de afișare",
    rateType: "Tip de evaluare",
    label: "Etichetă",
    contentMode: "Mod de conținut",
    imageFit: "Potrivirea imaginii și miniaturilor",
    altText: "Text alternativ",
    height: "Înălțime",
    penColor: "Culoarea stiloului",
    backgroundColor: "Culoarea fundalului",
    templateElements: "Elemente template",
    operator: "Operator",
    isVariable: "Este variabil",
    runExpression: "Rulează expresia",
    showCaption: "Arată subtitlul",
    iconName: "Nume pictogramă",
    iconSize: "Dimensiunea pictogramei",
    precision: "Precizie",
    matrixDragHandleArea: "Zona de manipulare a matricei",
    backgroundImage: "Imagine de fundal",
    backgroundImageFit: "Potrivirea imaginii de fundal",
    backgroundImageAttachment: "Atașament imagine de fundal",
    backgroundOpacity: "Opacitatea fundalului",
    selectToRankEnabled: "Permite clasificarea selectivă",
    selectToRankAreasLayout: "Alinierea zonei de clasificare",
    selectToRankEmptyRankedAreaText: "Text de afișat dacă toate opțiunile sunt selectate",
    selectToRankEmptyUnrankedAreaText: "Textul substitut pentru zona de clasificare",
    allowCameraAccess: "Permite accesul la cameră",
    scaleColorMode: "Modul de culoare al pictogramei de evaluare",
    rateColorMode: "Schema de culori a pictogramelor Smileys",
    copyDisplayValue: "Copiază valoarea afișată",
    effectiveColSpan: "Span de coloană eficient",
    progressBarInheritWidthFrom: "Lățimea zonei barei de progres"
  },
  theme: {
    advancedMode: "Mod avansat",
    pageTitle: "Pagină",
    questionTitle: "Caseta de întrebare",
    editorPanel: "Element de intrare",
    lines: "Linii",
    primaryDefaultColor: "Implicit",
    primaryDarkColor: "Hover",
    primaryLightColor: "Selectat",
    backgroundDimColor: "Culoarea fundalului",
    cornerRadius: "Raza colțului",
    backcolor: "Fundal implicit",
    hovercolor: "Fundal la trecere",
    borderDecoration: "Decorarea bordurii",
    fontColor: "Culoarea fontului",
    backgroundColor: "Culoarea fundalului",
    primaryForecolor: "Culoare implicită",
    primaryForecolorLight: "Culoare dezactivată",
    font: "Font",
    borderDefault: "Mai întunecat",
    borderLight: "Mai deschis",
    fontFamily: "Familia de fonturi",
    fontWeightRegular: "Regular",
    fontWeightHeavy: "Heavy",
    fontWeightSemiBold: "Semi-bold",
    fontWeightBold: "Bold",
    color: "Culoare",
    placeholderColor: "Culoarea textului substitut",
    size: "Dimensiune",
    opacity: "Opacitate",
    boxShadowX: "X",
    boxShadowY: "Y",
    boxShadowAddRule: "Adăugați efect de umbră",
    boxShadowBlur: "Blur",
    boxShadowSpread: "Întindere",
    boxShadowDrop: "Drop",
    boxShadowInner: "Interior",
    names: {
      default: "Implicit",
      sharp: "Sharp",
      borderless: "Fără bordură",
      flat: "Flat",
      plain: "Simplu",
      doubleborder: "Bordură dublă",
      layered: "Stratificat",
      solid: "Solid",
      threedimensional: "3D",
      contrast: "Contrast"
    },
    colors: {
      teal: "Teal",
      blue: "Albastru",
      purple: "Violet",
      orchid: "Orhidee",
      tulip: "Lalea",
      brown: "Maro",
      green: "Verde"
    }
  }
};

editorLocalization.locales["ro"] = roStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// pe.validateVisitedEmptyFields: "Validate empty fields on lost focus" => "Validarea câmpurilor goale pentru focalizarea pierdută"
// pehelp.validateVisitedEmptyFields: "Enable this option to trigger validation when a user focuses on an empty input field and then leaves it without making any changes." => "Activați această opțiune pentru a declanșa validarea atunci când un utilizator se concentrează pe un câmp de introducere gol și apoi îl lasă fără a efectua modificări."
// progressBarInheritWidthFrom.survey: "Same as survey" => "La fel ca sondajul"
// progressBarInheritWidthFrom.container: "Same as container" => "La fel ca containerul"
// file.allowImagesPreview: "Displays thumbnail previews for uploaded files when possible. Unselect if you want to show file icons instead." => "Afișează previzualizări în miniatură pentru fișierele încărcate atunci când este posibil. Deselectați dacă doriți să afișați pictogramele fișierelor."
// pehelp.progressBarInheritWidthFrom: "The \"Same as container\" option auto-adjusts the progress bar area width to fit into the HTML element the survey is placed in." => "Opțiunea \"La fel ca containerul\" ajustează automat lățimea zonei barei de progres pentru a se potrivi cu elementul HTML în care este plasat sondajul."
// p.progressBarInheritWidthFrom: "Progress bar area width" => "Lățimea zonei barei de progres"
// maskType.none: "None" => "Niciunul"
// maskType.pattern: "Pattern" => "Model"
// maskType.numeric: "Numeric" => "Numerică"
// maskType.datetime: "Date and Time" => "Data și ora"
// maskType.currency: "Currency" => "Valută"

// inputTextAlignment.auto: "Auto" => "Automobil"
// inputTextAlignment.left: "Left" => "Stânga"
// inputTextAlignment.right: "Right" => "Dreapta"
// pehelp.inputTextAlignment: "Select how to align input value within the field. The default setting \"Auto\" aligns the input value to the right if currency or numeric masking is applied and to the left if not." => "Selectați modul de aliniere a valorii de intrare în câmp. Setarea implicită \"Auto\" aliniază valoarea de intrare la dreapta dacă se aplică mascare monedară sau numerică și la stânga dacă nu."
// p.inputTextAlignment: "Input value alignment" => "Alinierea valorilor de intrare"